import React from 'react';
import { Card } from '@/components/ui/card';
import { formatDistanceToNow } from 'date-fns';

export default function ActivityFeed({ activities }) {
  if (!activities.length) {
    return (
      <Card className="p-6">
        <h3 className="font-semibold text-sm mb-4">Recent Activity</h3>
        <p className="text-sm text-muted-foreground">No activity yet.</p>
      </Card>
    );
  }

  return (
    <Card className="p-6">
      <h3 className="font-semibold text-sm mb-4">Recent Activity</h3>
      <div className="space-y-3">
        {activities.slice(0, 10).map(a => (
          <div key={a.id} className="flex gap-3 items-start">
            <div className="w-2 h-2 rounded-full bg-accent mt-1.5 shrink-0" />
            <div className="min-w-0">
              <p className="text-xs leading-relaxed">
                <span className="font-medium">{a.user_name || a.user_email}</span>
                {' '}{a.action}
                {a.details && <span className="text-muted-foreground"> — {a.details}</span>}
              </p>
              <p className="text-[10px] text-muted-foreground mt-0.5">
                {formatDistanceToNow(new Date(a.created_date), { addSuffix: true })}
              </p>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}